export default __webpack_public_path__ + "static/media/cholet.f3a1a350.jpg";